import axios from 'axios';

var crypto = require('crypto');
const Hosts = require('../src/Hosts');
//const axios = require('axios');
//import Resizer from "react-image-file-resizer";
var Resizer = require('react-image-file-resizer');

export const requests = async (url, request_type, body_data) => {

    let localtoken = (JSON.parse(localStorage.getItem('token')))
    //console.log('TOKEN NO UTILS:', localtoken)
    const requestOptions = {
        method: request_type,

        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + (localtoken === null ? '' : localtoken.token)
        },
        body: JSON.stringify(body_data)

    }
    // console.log('----------->', localtoken)
    // console.log('----------->', url)
    // console.log('----------->', requestOptions)

    return await fetch(url, requestOptions).then(response => response.json())
    //.then(res => { //console.log(res); return res })
}


export const requests_file = async (url, request_type, body_data) => {

    let localtoken = (JSON.parse(localStorage.getItem('token')))
    //console.log('TOKEN NO UTILS:', localtoken)

    const requestOptions = {
        method: request_type,
        headers: {
            'Authorization': 'Bearer ' + (localtoken === null ? '' : localtoken.token)
        },
        body: body_data

    }
    //console.log(localtoken)
    return await fetch(url, requestOptions).then(response => response.json())
    //.then(res => { //console.log(res); return res })
}


export const simpleGet = async (url) => {
    //'Content-Type': '*/*',
    const requestOptions = {
        method: 'GET',
        mode: 'cors',
        headers: {
            'Access-Control-Allow-Origin': '*'
        },
    }
    // console.log('----------->', localtoken)
    // console.log('----------->', url)
    // console.log('----------->', requestOptions)

    return await fetch(url, requestOptions).then(response => response)
}

export const simpleAxiosGet = async (url, path) => {
    console.log('&&&&&&&&&&&&&& URL:', url + path)

    return await axios.get(url + path)
        .then(response => response.data)
        .then(res => {
            // console.log('res', res)
            return res
        })
        .catch(erro => {
            console.log('ERROR1', erro)  
            return ''
        })

}

export const reqGET = async (url) => {
    return await requests(url, 'GET')
}

export const reqPOST = async (url, data) => {
    return await requests(url, 'POST', data)
}

export const reqPUT = async (url, data) => {
    return await requests(url, 'PUT', data)
}

export const reqDELETE = async (url, data) => {
    return await requests(url, 'DELETE', data)
}

export const reqFILE = async (url, data) => {
    return await requests_file(url, 'POST', data)
}

export const load_countries_pt = async () => {
    return await reqGET(`${Hosts.SIMCore_API}/countries/langpt/list`)
}


export const load_countries_en = async () => {
    return await reqGET(`${Hosts.SIMCore_API}/countries/langen/list`)
}


export const load_countries = async (lang) => {
    return await reqGET(`${Hosts.SIMCore_API}/countries/lang${lang}/list`)
}

export const load_districts_pt = async () => {
    return await reqGET(`${Hosts.SIMCore_API}/countries/pt/districts`)
}

export const load_cities_of_district_pt = async district => {
    return await reqGET(`${Hosts.SIMCore_API}/countries/pt/citiesofdistrict/${district}`)
}

export const load_district_of_city_pt = async city => {
    return await reqGET(`${Hosts.SIMCore_API}/countries/pt/districtofcity/${city}`)
}

export const load_freguesias_pt = async city => {
    return await reqGET(`${Hosts.SIMCore_API}/countries/pt/villagesofcity/${city}`)
}

export const get_vat_info = async vat => {
    return await reqGET(`${Hosts.SIMCore_API}/vat/${vat}`)
}


export const select_option_util_fun = (arg, set_fun, field) => {
    set_fun(...[arg.map(k => ({ value: k[field], label: k[field] }))])
}

export const select_regist_util_fun = (arg, field) => {
    return arg[0][field]
}


export const obter_cidades_por_distrito = (distrito, set_fun) => load_cities_of_district_pt(distrito).then(res => select_option_util_fun(res.data, set_fun, 'langpt_cc'))

export const obter_distrito_por_cidade = (cidade) => load_district_of_city_pt(cidade).then(res => { return select_regist_util_fun(res.data, 'langpt_dt') })

export const obter_freguesias_por_cidade = (cidade, set_fun) => load_freguesias_pt(cidade).then(res => select_option_util_fun(res.data, set_fun, 'langpt_fr'))

export const obter_paises_em_pt = set_fun => load_countries_pt().then(res => select_option_util_fun(res.data, set_fun, 'langpt'))
export const obter_paises_em_en = set_fun => load_countries_en().then(res => select_option_util_fun(res.data, set_fun, 'langen'))
export const obter_paises_by_lang = (set_fun, lang) => load_countries(lang).then(res => select_option_util_fun(res.data, set_fun, 'lang' + lang))

export const obter_distritos_pt = set_fun => load_districts_pt().then(res => select_option_util_fun(res.data, set_fun, 'langpt_dt'))


export const passwordHash = password => crypto.createHash('md5').update(password).digest("hex")
export const gerarPassword = () => {
    return Math.random().toString(36).slice(-10);
}

export const pattern_vat =
    '^((AT)?U[0-9]{8}|(BE)?0[0-9]{9}|(BG)?[0-9]{9,10}|(CY)?[0-9]{8}L|(CZ)?[0-9]{8,10}|(DE)?[0-9]{9}|(DK)?[0-9]{8}|(EE)?[0-9]{9}|(EL|GR)?[0-9]{9}|(ES)?[0-9A-Z][0-9]{7}[0-9A-Z]|(FI)?[0-9]{8}|(FR)?[0-9A-Z]{2}[0-9]{9}|(GB)?([0-9]{9}([0-9]{3})?|[A-Z]{2}[0-9]{3})|(HU)?[0-9]{8}|(IE)?[0-9]S[0-9]{5}L|(IT)?[0-9]{11}|(LT)?([0-9]{9}|[0-9]{12})|(LU)?[0-9]{8}|(LV)?[0-9]{11}|(MT)?[0-9]{8}|(NL)?[0-9]{9}B[0-9]{2}|(PL)?[0-9]{10}|(PT)?[0-9]{9}|(RO)?[0-9]{2,10}|(SE)?[0-9]{12}|(SI)?[0-9]{8}|(SK)?[0-9]{10})$'

//variavél ATUALIZADA sem o pattern do Reino Unido e com o pattern da Croácia 
export const pattern_vat_NEW = 
'^((AT)?U[0-9]{8}|(BE)?0[0-9]{9}|(BG)?[0-9]{9,10}|(CY)?[0-9]{8}L|(CZ)?[0-9]{8,10}|(DE)?[0-9]{9}|(DK)?[0-9]{8}|(EE)?[0-9]{9}|(EL|GR)?[0-9]{9}|(ES)?[0-9A-Z][0-9]{7}[0-9A-Z]|(FI)?[0-9]{8}|(FR)?[0-9A-Z]{2}[0-9]{9}|(HU)?[0-9]{8}|(IE)?[0-9]S[0-9]{5}L|(IT)?[0-9]{11}|(LT)?([0-9]{9}|[0-9]{12})|(LU)?[0-9]{8}|(LV)?[0-9]{11}|(MT)?[0-9]{8}|(NL)?[0-9]{9}B[0-9]{2}|(PL)?[0-9]{10}|(PT)?[0-9]{9}|(RO)?[0-9]{2,10}|(SE)?[0-9]{12}|(SI)?[0-9]{8}|(SK)?[0-9]{10}|(HR)?[0-9]{11})$'



export const pattern_email = '^[a-z0-9._%+\\-]+@[a-z0-9.\\-]+.[a-z]{2,4}$';

export const slots_duration = 15;

export const set_language = (lang) => {
    localStorage.setItem('lang', lang);
}

export const content_language = [
    {
        id: '1',
        code: 'pt'
    },
    {
        id: '2',
        code: 'en'
    },
    {
        id: '3',
        code: 'es'
    },
    {
        id: '4',
        code: 'fr'
    }
];

export const replace_slug_string = (string) => {

    let array_search = ['á', 'à', 'ã', 'â', 'ó', 'ò', 'õ', 'ô', 'é', 'è', 'ê', 'í', 'ì', 'î', 'ú', 'ù', 'û', 'ç', 'ö']
    let array_replace = ['a', 'a', 'a', 'a', 'o', 'o', 'o', 'o', 'e', 'e', 'e', 'i', 'i', 'i', 'u', 'u', 'u', 'c', 'o']

    string = string.toLowerCase()
    array_search.forEach((el, k) => {
        string = string.replaceAll(el, array_replace[k])
    })
    string = string.replace(/[^a-zA-Z0-9 -]/g, '')
    string = string.replaceAll(' ', '-')

    return string
}


// INTERFACE CHECKING
export const check_interface = (data_field, interface_field) => data_field === undefined ? interface_field : data_field


// REPO UTILS


export const repo_base_link = (resource) => Hosts.REPO + "static/assets/" + resource + "/";

export const repo_gest_link = (resource) => Hosts.REPO + "static/gest/assets/" + resource + "/";

export const repo_favicon_link = (resource) => repo_base_link("favicon") + resource;
export const repo_logo_link = (resource) => repo_base_link("logo") + resource;
export const repo_img_link = (resource) => repo_base_link("img") + resource;
export const repo_banner_link = (resource) => repo_base_link("banner") + resource;


export const repo_menu_icon_link = (resource) => repo_gest_link("menu_icon") + resource;
export const repo_icons_link = (resource) => repo_gest_link("icons") + resource;


export const get_language = () => {
    let tmp = localStorage.getItem(Hosts.APP_TOKEN_NAME + '_lang')
    return tmp ? tmp : 'pt';
}

export const get_my_fact_company = async (company_code) => {

    let companies = await reqGET(`${Hosts.SIMCore_API}/entities/special/${company_code}/company`)
    //console.log(companies)
    return companies.data.filter(company => company.info.ativo === true)[0]
    
}

export const get_fact_legacy_info = async () =>{

    let localtoken = (JSON.parse(localStorage.getItem('token')))
    //console.log('-----------> 0 >:',localtoken.user_info.companycode)
    let result = await get_my_fact_company(localtoken.user_info.companycode)

    if (result !== undefined)
    {
        let to_send =  {legacy_access: result.info.legacy_access}
        console.log('-----------> 1 >:', to_send)
        return to_send

    }
    
    return {}
}



export const normalize_from_db_to_data_interface = (data_interface_from_code, data_interface_from_db) => {

    const keys_data_interface_from_code = Object.keys(data_interface_from_code);

    keys_data_interface_from_code.forEach(key_in_code => {

        //console.log('TYPEOFF Key:Value:', key_in_code, data_interface_from_db[key_in_code], typeof (data_interface_from_code[key_in_code]))
        let tmp_key_of = typeof (data_interface_from_code[key_in_code])
        if (tmp_key_of === 'string' || tmp_key_of === 'number' || tmp_key_of === 'boolean') {
            if (data_interface_from_db[key_in_code] !== undefined) {
                //console.log('Atribuição')
                data_interface_from_code[key_in_code] = data_interface_from_db[key_in_code]
            }

        } else {
            if (Array.isArray(data_interface_from_code[key_in_code])) {
                //console.log('É ARRAY key:', key_in_code, Array.isArray(data_interface_from_code[key_in_code]))
                //console.log('É ARRAY da DB:', data_interface_from_db[key_in_code])

                if (data_interface_from_db[key_in_code].length > 0) {
                    //console.log('É ARRAY e é lenght>0 key:', key_in_code)

                    let obj = { ...data_interface_from_code[key_in_code][0] }
                    data_interface_from_code[key_in_code] = data_interface_from_db[key_in_code].map(item_db =>

                        normalize_from_db_to_data_interface(obj, item_db)
                    )
                }
            }
            if (typeof (data_interface_from_code[key_in_code]) === 'object') {
                if (data_interface_from_db[key_in_code] !== undefined) {
                    normalize_from_db_to_data_interface(data_interface_from_code[key_in_code], data_interface_from_db[key_in_code])
                }
                //console.log('É um tipo:', typeof (data_interface_from_code[key_in_code]))
            }
        }
    })
    return data_interface_from_code
}










export const handle_compressed_image_upload = async (file, set_fun) => {

    //const file = e.target.files[0];
    // QUEM ALTERAR A EXTENSION TEM QUE ALTERAR AQUI TAMBEM
    const name = file.name.split('.')[0] + '.webp'
    //console.log('handleCompressedUpload info FILE:', file);
    Resizer.default.imageFileResizer(
        file, // the file from input
        1920, // width
        1920, // height
        "WEBP", // compress format WEBP, JPEG, PNG
        90, // quality
        0, // rotation
        (uri) => {
            console.log('handleCompressedUpload info:', uri);
            //set_dados(dados.current.info.profile_photo = uri)
            uri.name = name
            set_fun(uri)
        },
        "blob", // blob or base64 default base64
        //1920, // width
        //1920, // height
    )
}

export const my_local_storage = {
    getItem(key) {
        return localStorage.getItem(key)
    },
    setItem(key, value, expiry) {
        // if the expiry time is 0, it means there is no need to add the item
        if (expiry === 0) 
            return

        localStorage.setItem(key, value)
        let timer;

        if(expiry) {
            timer = setTimeout(() => {
                this.removeItem(key);
                timer && clearTimeout(timer)
            }, expiry)
        }

    },
    removeItem(key) {
        localStorage.removeItem(key)
    },
    clear() {
        localStorage.clear()
    }
}

export const translate = (key_list, lang) => {
    let res = ''
    // console.log('Translate:',key_list,':',lang,'=', res)
    try {
        res = key_list.filter(e => e[lang])[0][lang]
        return res
    }
    catch (error) {
        return res
    }
}

export const functionSendMail = async (sendFrom, sendTo, sendToCC, subject, content, attachment) => {

    const mailHtmlTop = '<html><head><link rel="preconnect" href="https://fonts.googleapis.com"><link rel="preconnect" href="https://fonts.gstatic.com" crossorigin><link href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,400;0,700;1,400;1,700&display=swap" rel="stylesheet"> </head><body style="background-color:' + Hosts.EMAIL_BODY_BACKGROUND_COLOR +'; font-family:poppins, helvetica, arial, sans-serif; ">' +
                            '<div style="width:100% !important; margin-top:0; margin-bottom:0; margin-right:0; margin-left:0; padding-top:0; padding-bottom:0; padding-right:0; padding-left:0; color:' + Hosts.EMAIL_TEXT_COLOR +';">' +
                                '<table border="0" align="center" cellpadding="0" cellspacing="0" style="margin-top:0; margin-bottom:0; padding-top:0; padding-bottom:0; padding-right:0; padding-left:0; border-collapse:collapse;">' +
                                    '<tr style="border-collapse: collapse;">' +
                                        '<td style="border-collapse: collapse; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE +'; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT  +';">' +
                                            '<table width="600" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 600px; background-color:' + Hosts.EMAIL_BACKGROUND_COLOR +'; border:1px solid transparent; border-collapse:collapse;">' +
                                                '<tr style="border-collapse: collapse;">' +
                                                    '<td align="left" class="logo" style="padding:0; border-collapse:collapse;">' +
                                                        '<a alt="' + Hosts.webSiteTitle + '" title="' + Hosts.webSiteTitle + '" href="' + Hosts.EMAIL_WEB_SITE_URL + '" target="_blank">' +
                                                            '<img style="width: 600px; height: 90px;" width="600" height="90" src="' + repo_banner_link("banner-email.jpg") + '"/>' +
                                                        '</a>'+
                                                    '</td>' +
                                                '</tr>' +
                                            '</table>'

    const mailHtmlBottom =  '<table width="600" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 600px; background-color:' + Hosts.FOOTER_EMAIL_COLOR +'; padding: 10px; border: 1px solid transparent; border-collapse:collapse;">' +
                                '<tr style="border-collapse: collapse;">' +
                                    '<td align="left" style="padding-bottom: 10px; padding-top: 10px; border-collapse:collapse; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.FOOTER_EMAIL_TEXT_SIZE +'; line-height:' + Hosts.FOOTER_EMAIL_TEX_LINE_HEIGHT  +';">' +
                                        '<div>'+
                                            '<div style="text-align: center; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.FOOTER_EMAIL_TEXT_SIZE +'; line-height:' + Hosts.FOOTER_EMAIL_TEX_LINE_HEIGHT  +'; color:' + Hosts.FOOTER_EMAIL_TEXT_COLOR +';">'+
                                                '<span style="text-transform: uppercase;">' + Hosts.webSiteTitle + '</span>'+
                                                '<br/>'+
                                                '<span>' + Hosts.webSiteAdress + '</span>'+
                                                '<br/>'+
                                                '<a alt="' + Hosts.webSiteTitle + '" title="' + Hosts.webSiteTitle + '" href="' + Hosts.EMAIL_WEB_SITE_URL + '" target="_blank" style="font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.FOOTER_EMAIL_TEXT_SIZE +'; line-height:' + Hosts.FOOTER_EMAIL_TEX_LINE_HEIGHT  +';"> '+
                                                    '<span style="color:' + Hosts.FOOTER_EMAIL_TEXT_COLOR +';font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.FOOTER_EMAIL_TEXT_SIZE +'; line-height:' + Hosts.FOOTER_EMAIL_TEX_LINE_HEIGHT  +'; text-decoration: underline" >'+ Hosts.EMAIL_WEB_SITE_URL +'</span>' +
                                                '</a>'+
                                            '</div>'+
                                        '</div>' +
                                    '</td>' +
                                '</tr>' +
                            '</table>' +
                        '</td>' +
                    '</tr>' +
                '</table>' +
            '</div>' +
        '<body>' +
    '<html>'

    let mailOptions = {
        from: sendFrom,
        // vários emails separados por virgulas
        to: sendTo.join(', '),
        //cc-> opcional
        cc: sendToCC.join(', '),
        subject: subject,
        html: ''
    };

    mailOptions.html = mailHtmlTop + content + mailHtmlBottom

    return await reqPOST(`${Hosts.SIMCore_API_MAIL}`, { data: mailOptions })
        .then(() => {

            return true

        })
        .catch(() => { 

            return false

        })
}



/*
module.exports = {
    reqGET,
    reqPOST,
    reqPUT,
    reqDELETE,
    reqFILE,

    obter_cidades_por_distrito,
    obter_distrito_por_cidade,
    obter_freguesias_por_cidade,
    obter_paises_em_pt,
    obter_distritos_pt,



    get_vat_info,

    passwordHash,
    gerarPassword,

    pattern_vat,
    pattern_email,

}*/